var map = {
	"./xinweiwo.png": "u0YA",
	"./xinweiwo0.png": "H4hp",
	"./xinweiwo1.png": "JyR8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a5Zm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/organize ^\.\/xinweiwo.*\.png$
// module id = a5Zm
// module chunks = 3